<router-outlet></router-outlet>
<alert></alert>
<toast></toast>
<!-- Modal boxes -->

<!-- modal-box:: Advance/Upcoming Draw -->
<div class="modal-box modal-xs modal-design1 drawModal" *ngIf="advanceDrawPopup" id="drawModal">
    <div class="modal-content">
        <div class="modal-header">
            <div class="modal-title">{{'dge.upcom_draw' | translate}}</div>
            <div class="modal-close" (click)="closeAdvDrawPopup()"><span></span></div>
        </div>
        <div class="modal-body">
            <ul class="inputDrawList">
                <li *ngFor="let drawData of gameData.drawRespVOs; let i = index;" (click)="advDrawChange(i, $event)">
                    <label [ngClass]="{'active' : drawData.drawStatus == 'ACTIVE'}">
                        <input type="checkbox" [(ngModel)]="drawChecked[i]" [disabled]="true">
                        <span class="chkval">
                            {{gameData.drawRespVOs[i].drawDateTime | date:'MMM d, y HH:mm'}}
                        </span>
                    </label>
                </li>
            </ul>
            <div class="error-div">
                <span class="error-msg" id="advError">
                    {{advanceDrawErrorMsg}}
                </span>
            </div>
        </div>
        <div class="modal-footer">
            <div class="buttonWrap" (click)="closeAdvDrawPopup()">
                <a>
                    <div class="cancelBtn button">
                        <div class="text">{{'dge.cancel' | translate}}</div>
                    </div>
                </a>
            </div>
            <div class="buttonWrap" (click)="advDrawSubmit()">
                <a>
                    <div class="goBtn button">
                        <div class="text">{{'dge.cont' | translate}}</div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
<!-- How to Play Modals -->
<div class="modal-box modal-sm modal-design1 helpModal hcModal" *ngIf="helpModalStatus[helpModalGameCode]"
    id="helpModal">
    <div class="modal-close" (click)="closeHelpModal()"><span></span></div>
    <div class="modal-content">
        <div class="modal-header">
            <div class="modal-title">{{'common.' + helpModalGameCode | translate}}</div>
        </div>
        <div class="modal-body" [innerHTML]="'howtoplay.' + helpModalGameCode | translate | safeHtml"></div>
    </div>
</div>
<!-- ## Note:- Landscape mode restriction -->
<div class="onlyPortrait">
    <div class="msgBox">
        <div class="iconWrap">
            <svg class="svgicon">
                <use xlink:href="assets/images/sprite-sheet.svg#icon-portrait"></use>
            </svg>
        </div>
        <div class="msg">
            <div class="line1">{{'common.land_supp' | translate}}</div>
            <div class="line2">{{'common.dev_rot' | translate}}</div>
        </div>
    </div>
</div>
<!-- Start Offer Conversion Pixel -->
<iframe [src]="conversionIframeSrc" scrolling="no" frameborder="0" width="1" height="1"></iframe>
<!-- End Offer Conversion Pixel -->